<template>
  <div class="card1">
    <div class="card2">
      <div class="container-fluid mt-4" v-for="item in certificate" :key="item.id">
          <div class="container-fluid" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
            <center><span class="text-black display-4" style="font-family: Certificate Font;">DEATH CERTIFICATE</span></center>
            <center><br><span class="text-black h5">This is to acknowledge the death of</span></center>
            <div class="row">
              <div class="col-4">
                <img src="@/assets/images/pray.png" height="80"/>
              </div>
              <div class="col-4 text-center"></div>
              <div class="col-4 text-end">
                <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="80"/></span>
                <span v-else><img src="@/assets/images/logo.png" height="80"/></span>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <h4 class="text-uppercase patient">{{ item.patient.name }}</h4> 
            </div>
            <hr class="hr-1 mt-n1 bg-dark">
            
            <div class="m-4 d-flex justify-content-center h5"> 
               <span>of <span>Age <span class="h4 text-black">{{ CalculateAge( item.patient.date_of_birth) }}</span></span> , 
                 sex <span class="h4 text-black">{{ item.patient.gender}}</span>, </span>

            </div>
            <div class="m-4 d-flex justify-content-center h5">
                <span>The immediate cause of death was <span class="h4 text-black">{{ item.cause }}</span>
                 </span>

            </div>
            <div class="m-4 d-flex justify-content-center h5">
                <span>on the <span class="h4 text-black">{{ item.date_of_death }}</span>
                 at <span class="h4 text-black">{{ userData.business }}</span>, <span class="text-black h5">{{ userData.location }}</span></span>
                 
            </div>
              
            <div class="text-center">
                <h5 style="color: black;" class="mt-5 text-center">Signature : .........................</h5>
                <p style="color:black;font-size:13px">Printed by : {{ userData.username }} | Via Afrimed Software | www.afrimed.com </p>
            </div>
          </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      certificate:[],
    };
  },
  created() {
    this.showCertificate();
  },
  methods: {
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
  
      CalculateAge(dateOfBirth) {
    let dob = new Date(dateOfBirth);
    const today = new Date();
    
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    if (age === 0) {
      const months = (today.getFullYear() - dob.getFullYear()) * 12 + today.getMonth() - dob.getMonth();
      return months + (months === 1 ? ' month' : ' months');
    } else {
      return age + (age === 1 ? ' year' : ' years');
    }
  },
    async showCertificate(){
      this.id=this.$route.query.id;
      let url = `/patientdeathcertificate/${this.id}`;
      await axios.get(url).then((response) => {
        this.certificate = response.data.certificates;
        setTimeout(() => {
            window.print();
            window.onafterprint=this.$router.go(-1);
        }, 500);
      });
    },
  },
};
</script>

<style>
  .card1{
    border: 5px solid black;
    margin: 10px;
  }
  .card2{
    border: 1px solid black;
    margin: 10px;
  }
  .patient{
    color: black;
    letter-spacing: 4px;
  }
  hr.hr-1 {
  margin: 100px;
  margin-bottom: 30px;
  border-top: 2px solid black;  
}
</style>